<template>
  <v-tooltip bottom>
    <span class="tag-wrapper" slot="activator">
      <v-img
        :src="getImagePath"
        :class="`food-tag ${svgClass} ${outOfStock ? 'out-of-stock' : ''}`"
        :height="sizePx"
        :width="sizePx"
        contain
      />
    </span>

    <span> {{ svgClass == 'GLUTENFREE' ? 'GLUTEN FRIENDLY' : svgClass }} </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    svgClass: {
      type: String,
      default: ''
    },
    sizePx: {
      type: Number,
      default: 20
    },
    outOfStock: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    getImagePath(){
      return `${process.env.VUE_APP_ASSET_PREFIX}/img/menu_item_tags/${this.svgClass}.svg`
    }
  }
}
</script>

<style scoped>
  .food-tag{
    display: inline-block;
    margin: 0 2px;

    position: relative;
    top: 4px;

    /* Force GPU compositing to prevent Safari iOS filter flash on initial render */
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  .food-tag.MILD,
  .food-tag.SPICY,
  .food-tag.SPICY2,
  .food-tag.SPICY3,
  .food-tag.HOT {
    filter: brightness(0) saturate(100%) invert(19%) sepia(99%) saturate(5000%) hue-rotate(0deg) brightness(90%) contrast(106%);
  }

  .food-tag.HEALTHY {
    filter: invert(16%) sepia(98%) saturate(3353%) hue-rotate(290deg) brightness(84%) contrast(123%);
  }

  .food-tag.RECOMMENDED {
    filter: invert(65%) sepia(81%) saturate(533%) hue-rotate(6deg) brightness(92%) contrast(101%);
  }

  .food-tag.PEANUT {
    filter: invert(22%) sepia(77%) saturate(1080%) hue-rotate(353deg) brightness(96%) contrast(95%);
  }

  .food-tag.VEGE {
    filter: invert(62%) sepia(97%) saturate(1264%) hue-rotate(351deg) brightness(100%) contrast(103%);
  }
  .food-tag.COLD {
    filter: invert(42%) sepia(96%) saturate(2139%) hue-rotate(164deg) brightness(99%) contrast(101%);
  }

  .food-tag.MUSHROOM {
    filter: invert(61%) sepia(13%) saturate(2288%) hue-rotate(337deg) brightness(91%) contrast(83%);
  }

  .food-tag.SHRIMP {
    filter: invert(57%) sepia(75%) saturate(3463%) hue-rotate(349deg) brightness(99%) contrast(92%);
  }

  .food-tag.SHELLFISH {
    filter: invert(93%) sepia(14%) saturate(7307%) hue-rotate(304deg) brightness(103%) contrast(91%);
  }

  .food-tag.MILK {
    filter: invert(86%) sepia(7%) saturate(4223%) hue-rotate(156deg) brightness(99%) contrast(95%);
  }

  .food-tag.VEGAN {
    filter: invert(49%) sepia(97%) saturate(357%) hue-rotate(67deg) brightness(103%) contrast(87%);
  }

  .food-tag.GLUTENFREE {
    filter: invert(75%) sepia(63%) saturate(1267%) hue-rotate(335deg) brightness(100%) contrast(89%);
  }

  .food-tag.SESAME {
    filter: brightness(0) saturate(100%) invert(68%) sepia(60%) saturate(466%) hue-rotate(359deg) brightness(102%) contrast(91%);
  }

  .food-tag.SARDINE {
    filter: brightness(0) saturate(100%) invert(72%) sepia(82%) saturate(2402%) hue-rotate(150deg) brightness(95%) contrast(88%);
  }

  .food-tag.HALAL {
    filter: brightness(0) saturate(100%) invert(25%) sepia(14%) saturate(3025%) hue-rotate(106deg) brightness(94%) contrast(85%);
  }

  /* Out of stock styles - remove color filters, just grayscale the original SVG */
  .food-tag.out-of-stock {
    filter: grayscale(100%) brightness(0.5);
    opacity: 0.3;
  }

  .tag-wrapper {
    display: inline-block;
  }

  /* Reduce icon brightness on mobile - applied to image directly to avoid
     Safari iOS filter stacking bug that causes color flash on scroll */
  @media (max-width: 768px) {
    .food-tag {
      filter: brightness(0.85);
    }
    .food-tag.MILD:not(.out-of-stock),
    .food-tag.SPICY:not(.out-of-stock),
    .food-tag.SPICY2:not(.out-of-stock),
    .food-tag.SPICY3:not(.out-of-stock),
    .food-tag.HOT:not(.out-of-stock) {
      filter: brightness(0) saturate(100%) invert(19%) sepia(99%) saturate(5000%) hue-rotate(0deg) brightness(76%) contrast(106%);
    }
    .food-tag.HEALTHY:not(.out-of-stock) {
      filter: invert(16%) sepia(98%) saturate(3353%) hue-rotate(290deg) brightness(71%) contrast(123%);
    }
    .food-tag.RECOMMENDED:not(.out-of-stock) {
      filter: invert(65%) sepia(81%) saturate(533%) hue-rotate(6deg) brightness(78%) contrast(101%);
    }
    .food-tag.PEANUT:not(.out-of-stock) {
      filter: invert(22%) sepia(77%) saturate(1080%) hue-rotate(353deg) brightness(82%) contrast(95%);
    }
    .food-tag.VEGE:not(.out-of-stock) {
      filter: invert(62%) sepia(97%) saturate(1264%) hue-rotate(351deg) brightness(85%) contrast(103%);
    }
    .food-tag.COLD:not(.out-of-stock) {
      filter: invert(42%) sepia(96%) saturate(2139%) hue-rotate(164deg) brightness(84%) contrast(101%);
    }
    .food-tag.MUSHROOM:not(.out-of-stock) {
      filter: invert(61%) sepia(13%) saturate(2288%) hue-rotate(337deg) brightness(77%) contrast(83%);
    }
    .food-tag.SHRIMP:not(.out-of-stock) {
      filter: invert(57%) sepia(75%) saturate(3463%) hue-rotate(349deg) brightness(84%) contrast(92%);
    }
    .food-tag.SHELLFISH:not(.out-of-stock) {
      filter: invert(93%) sepia(14%) saturate(7307%) hue-rotate(304deg) brightness(88%) contrast(91%);
    }
    .food-tag.MILK:not(.out-of-stock) {
      filter: invert(86%) sepia(7%) saturate(4223%) hue-rotate(156deg) brightness(84%) contrast(95%);
    }
    .food-tag.VEGAN:not(.out-of-stock) {
      filter: invert(49%) sepia(97%) saturate(357%) hue-rotate(67deg) brightness(88%) contrast(87%);
    }
    .food-tag.GLUTENFREE:not(.out-of-stock) {
      filter: invert(75%) sepia(63%) saturate(1267%) hue-rotate(335deg) brightness(85%) contrast(89%);
    }
    .food-tag.SESAME:not(.out-of-stock) {
      filter: brightness(0) saturate(100%) invert(68%) sepia(60%) saturate(466%) hue-rotate(359deg) brightness(87%) contrast(91%);
    }
    .food-tag.SARDINE:not(.out-of-stock) {
      filter: brightness(0) saturate(100%) invert(72%) sepia(82%) saturate(2402%) hue-rotate(150deg) brightness(81%) contrast(88%);
    }
    .food-tag.HALAL:not(.out-of-stock) {
      filter: brightness(0) saturate(100%) invert(25%) sepia(14%) saturate(3025%) hue-rotate(106deg) brightness(80%) contrast(85%);
    }
  }
</style>
